import { IconNameV2, IconV2 } from 'common/icon/iconV2.js';
import { MarkerOptions } from 'components/map/themes/pill-theme.js';
import { MarkerV2Wrapper } from './wrapper-pill-v2.js';

export const PillV2 = ({
  className,
  icons = [],
  label,
  themeProps,
}: {
  label?: string;
  className?: string;
  icons?: Array<IconNameV2 | undefined>;
  themeProps?: Pick<MarkerOptions, 'text' | 'border' | 'background'>;
}) => {
  return (
    <MarkerV2Wrapper themeProps={themeProps} className={className}>
      {icons.map((icon, index) => (
        <IconV2 key={index} icon={icon} />
      ))}
      {label && <span className="u-span-width u-text-sm u-textBold u-textNoWrap">{label}</span>}
    </MarkerV2Wrapper>
  );
};
